<template>
  <div class="content-box">
    <Title />
    <div class="title-right">
      <!-- <el-link href="https://www.100ec.cn/zt/wswjsxfpgyl/" target='_blank'>
        <img src="https://www.100ec.cn/Public/home/images/dd.gif"
      /></el-link> -->
      <el-link href="https://www.100ec.cn/detail--6646411.html" target='_blank'>
        <img src="https://www.100ec.cn/Public/home/images/xfwq.gif"
      /></el-link>
      
    </div>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
    >
      <el-menu-item
        :index="String(index + 1)"
        v-for="(i, index) of dataNav"
        :key="index"
        @click="handleSelect(index)"
      >
        {{ i.label }}</el-menu-item
      >
    </el-menu>

    <div class="mobile-select">
      <el-select v-model="name" @change="handleSelect2">
        <el-option
          v-for="item in dataNav"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>

    <Textlist />
  </div>
</template>

<script>
export default {
  name: "broadCast",
  data() {
    return {
      activeIndex: "1",
      name: "滚动播报",
      dataNav: [
        {
          value: "双11曝光",
          label: "滚动播报",
        },
        {
          value: "电诉宝",
          label: "电诉宝",
        },{
          value: "仅退款",
          label: "仅退款",
        },
        {
          value: "投诉案例",
          label: "投诉案例",
        },
        {
          value: "信息泄露",
          label: "信息泄露",
        },
        {
          value: "杀熟",
          label: "大数据杀熟",
        },
        {
          value: "二选一",
          label: "二选一",
        },
        {
          value: "虚假宣传",
          label: "虚假宣传",
        },
        {
          value: "退款",
          label: "退款",
        },
        {
          value: "售假",
          label: "售假",
        },
        {
          value: "隐私侵权",
          label: "隐私侵权",
        },
        {
          value: "刷单",
          label: "刷单",
        },
        {
          value: "默认搭售",
          label: "默认搭售",
        },
        {
          value: "偷税",
          label: "偷税",
        },
        {
          value: "垄断",
          label: "垄断",
        },
        {
          value: "传销",
          label: "网络传销",
        },
        {
          value: "霸王条款",
          label: "霸王条款",
        },
        {
          value: "杀猪盘",
          label: "杀猪盘",
        },
        {
          value: "消协",
          label: "消协",
        },
        {
          value: "消保委",
          label: "消保委",
        },
        {
          value: "市监",
          label: "市监",
        },
        {
          value: "12315",
          label: "12315",
        },
        {
          value: "约谈",
          label: "约谈",
        },
        {
          value: "整治",
          label: "整治",
        },
      ],
      params: {
        json: 0,
      },
    };
  },
  created() {
    this.$store.commit("textparams", this.params);
    this.$store.commit("changeKeys", this.dataNav[0].value);
    this.$store.dispatch("getText");
  },
  methods: {
    handleSelect(index) {
      this.$store.commit("changeKeys", this.dataNav[index].value);
      this.$store.dispatch("getText");
    },
    handleSelect2(value) {
      this.$store.commit("changeKeys", value);
      this.$store.dispatch("getText");
    },
  },
};
</script>
<style scoped>
.title {
  position: relative;
}
.title-right {
  position: absolute;
  left: 195px;
  top: 65px;
}
.title-right img {
  width: 580px;
  height: 70px;
}
@media (max-width: 1100px) {
  .title-right {
    position: static;
    margin: 10px 0;
  }
  .title-right img {
    width: 100%;
    height: 50px;
  }
}
</style>